export const iconFontAwesomeCommunicationMobile = (
	<i className="fa-solid fa-mobile"></i>
);
